var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      !_vm.hideButton
        ? _c(
            "button",
            {
              class: _vm.btnClasses,
              attrs: { disabled: _vm.isDisabled },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.showModal = true
                },
              },
            },
            [_vm._t("buttonTxt")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("modal", {
        attrs: { value: _vm.showModal, showFooter: false },
        scopedSlots: _vm._u(
          [
            {
              key: "header",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "modal-title" },
                    [_vm._t("modalTitle")],
                    2
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm._t("modalBody"),
                  _vm._v(" "),
                  _vm.isLoading
                    ? [_c("loader")]
                    : _vm.isError
                    ? [
                        _c("HasError", { attrs: { e: _vm.isError } }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "button is-cancel",
                            attrs: { href: "javascript:void(0);" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.closeModal.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("close")))]
                        ),
                      ]
                    : [
                        _vm.useTypedConfirmation
                          ? _c(
                              "div",
                              { staticClass: "mb15" },
                              [
                                _c("p", {
                                  staticClass: "mt15-xs",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("typeToConfirm", {
                                        text: `<code>${_vm.confirmationText}</code>`,
                                      })
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("textInput", {
                                  attrs: {
                                    validation: _vm.typedConfirmationValidation,
                                  },
                                  on: { input: _vm.validateTypedConfirmation },
                                  model: {
                                    value: _vm.typedConfirmation,
                                    callback: function ($$v) {
                                      _vm.typedConfirmation = $$v
                                    },
                                    expression: "typedConfirmation",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mt15-xs" }, [
                          _c(
                            "button",
                            {
                              class: _vm.actionClasses,
                              attrs: { disabled: _vm.isConfirmDisabled },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.doConfirm()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("yes")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "button is-cancel",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.closeModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("cancel")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ],
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }